import { formatName, getSupportStatusCode } from "../functions"

function formatTask(task) {
  return {
    id: task.id,
    code: getSupportStatusCode(task.status.status),
    title: task.name,
    color: task.status.color,
    status: formatName(task.status.status),
    description: task.description,
  }
}

export const formatResponses = {
  task: (task) => formatTask(task),
  tasks: (tasks) => tasks.map(formatTask),
};
